import {ExtendBorrowDetailContainer} from "../../../containers/borrowSystem/ChangeAndExtendBorrowForm/ExtendBorrowDetailContainer"
export function ExtendBorrowDetailPage () {
    return(
        <ExtendBorrowDetailContainer/>
    )
}